<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{event.id? 'Edit' : 'Add' }} task</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                dense
                outlined
                v-model="event.name"
                label="Name"
                @input="$v.event.name.$touch()"
                @blur="$v.event.name.$touch()"
                :error-messages="eventNameErrors"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-menu
                v-model="menu_date"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="event.date"
                    label="Date"
                    prepend-icon="mdi-calendar-today"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.event.date.$touch()"
                    @blur="$v.event.date.$touch()"
                    :error-messages="eventDateErrors"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="event.date" @input="menu_date = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-menu
                ref="time_from_menu"
                v-model="menu_time_from"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="event.startTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="event.startTime"
                    label="Time from"
                    prepend-icon="mdi-calendar"
                    readonly
                    :disabled="!event.date"
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.event.startTime.$touch()"
                    @blur="$v.event.startTime.$touch()"
                    :error-messages="eventStartErrors"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu_time_from"
                  v-model="event.startTime"
                  full-width
                  format="24hr"
                  :allowed-minutes="allowedMinutes"
                  :allowed-hours="allowedHours"
                  @click:minute="$refs.time_from_menu.save(event.startTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-menu
                ref="time_to_menu"
                v-model="menu_time_to"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="event.endTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="event.endTime"
                    label="Time to"
                    prepend-icon="mdi-calendar"
                    readonly
                    :disabled="!event.startTime"
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.event.endTime.$touch()"
                    @blur="$v.event.endTime.$touch()"
                    :error-messages="eventEndErrors"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu_time_to"
                  v-model="event.endTime"
                  full-width
                  format="24hr"
                  :min="event.startTime"
                  :allowed-minutes="allowedMinutes"
                  :allowed-hours="allowedHours"
                  @click:minute="$refs.time_to_menu.save(event.endTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                v-model="event.description"
                label="Description"
                @input="$v.event.description.$touch()"
                @blur="$v.event.description.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">Close</v-btn>
        <v-btn color="primary" :disabled="this.$v.$invalid" light @click="save">
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  name: "AppointmentDialog",
  props: ["event"],
  data: () => ({
    isVisible: false,
    menu_date: false,
    menu_time_from: false,
    menu_time_to: false,
    isLoading: false
  }),
  validations: {
    event: {
      name: { required },
      date: { required },
      startTime: { required },
      endTime: { required },
      description: {}
    }
  },
  methods: {
    allowedHours(v) {
      return v >= this.$store.getters.startingHour;
    },
    //allowedHours: v => console.log(v),
    allowedMinutes: v => v % 5 === 0,
    allowedStep: v => v % 5 === 0,

    closeDialog() {
      this.isVisible = false;
      this.$emit("close");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let appointment = {
        appointment: {
          id: this.event.id ?? null,
          type: "task",
          name: this.event.name,
          startTimeStamp: `${this.event.date} ${this.event.startTime}`,
          endTimeStamp: `${this.event.date} ${this.event.endTime}`,
          description: this.event.description,
          companyId: this.$store.getters.user.details.companyId,
          assignedTo: this.$store.getters.SelectedUser.id,
          createdByUserID: this.$store.getters.user.details.id
        }
      };
      let mutation = ` mutation saveAppointment($appointment: SaveAppointment!) {
                                saveAppointment(appointment: $appointment) {
                                id
                                }
                            }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables: appointment
        })
        .then(res => {
          if (res.data.data.saveAppointment) {
            this.closeDialog();
            this.showSuccess("Task saved!");
          }
        })
        .catch(() => this.showError("Error occured while saving task!"));
    }
  },
  computed: {
    // start: {
    //   get() {
    //     return moment(this.event.start).format("HH:mm");
    //   },
    //   set(val) {
    //     this.event.start = val;
    //   }
    // },
    // end: {
    //   get() {
    //     return moment(this.event.end).format("HH:mm");
    //   },
    //   set(val) {
    //     this.event.end = val;
    //   }
    // },
    eventNameErrors() {
      const errors = [];
      if (!this.$v.event.name.$dirty) return errors;
      !this.$v.event.name.required && errors.push("Name is required");
      return errors;
    },
    eventDateErrors() {
      const errors = [];
      if (!this.$v.event.date.$dirty) return errors;
      !this.$v.event.date.required && errors.push("Date is required");
      return errors;
    },
    eventStartErrors() {
      const errors = [];
      if (!this.$v.event.startTime.$dirty) return errors;
      !this.$v.event.startTime.required && errors.push("Time is required");
      return errors;
    },
    eventEndErrors() {
      const errors = [];
      if (!this.$v.event.endTime.$dirty) return errors;
      !this.$v.event.endTime.required && errors.push("Time is required");
      return errors;
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.$v.$reset();
      }
    }
  }
};
</script>

<style>
</style>